import React, { useState, useContext, useEffect } from 'react'
import { DateTime } from 'luxon'

export interface FiltersState {
  tags: string[]
  startDate?: DateTime
  endDate?: DateTime
}

type FilterType = 'tags' | 'startDate' | 'endDate'

type SetFiltersFunc = React.Dispatch<React.SetStateAction<FiltersState>>

interface FiltersContextState {
  filters: FiltersState
  setFilters: SetFiltersFunc
}

export const FiltersContext: React.Context<FiltersContextState> = React.createContext({
  filters: {
    tags: [] as Array<string>,
  },
  setFilters: ((_state: FiltersState) => {}) as SetFiltersFunc,
})

export const FiltersConsumer = FiltersContext.Consumer

type FilterProviderProps = React.PropsWithChildren<FiltersState>

export const FiltersProvider: React.FunctionComponent<FilterProviderProps> = ({ children, ...initialState }) => {
  const [filters, setFilters] = useState<FiltersState>(initialState)

  useEffect(() => {
    // TODO: fixme
    if (JSON.stringify(initialState) !== JSON.stringify(filters)) {
      setFilters(initialState)
    }
  }, [initialState, filters])

  return <FiltersContext.Provider value={{ filters, setFilters }}>{children}</FiltersContext.Provider>
}

export function useFilters(): [FiltersState, SetFiltersFunc] {
  const filtersContext = useContext(FiltersContext)
  return [filtersContext.filters, filtersContext.setFilters]
}

export function useFilter(type: FilterType) {
  const [filters, setFilters] = useFilters()

  const setFilter = (value: any) => {
    setFilters((prevState) => {
      if (prevState[type] === value) {
        return prevState
      }
      return { ...prevState, [type]: value }
    })
  }

  return [filters[type], setFilter]
}
